import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import ic_doc_download_light from "../../assets/images/ic_doc_download_light.svg";
import ic_view_light from "../../assets/images/ic_view_light.svg";
import ic_repeat from "../../assets/images/ic_repeat.svg";
import ic_repeat_green from "../../assets/images/ic_repeat_green.svg";
import chatting_dummy from "../../assets/images/chatting_dummy.png";
import video_dummy from "../../assets/images/video_dummy.png";

import ic_invoice from "../../assets/images/ic_invoice.svg";
import ic_arrow_right_white from "../../assets/images/ic_right_arrow_circle.svg";
import dr_1 from "../../assets/images/dr_1.png";
import ic_doc_download from "../../assets/images/ic_doc_download.svg";
import ic_view from "../../assets/images/ic_view.svg";
import ic_video from "../../assets/images/ic_video.svg";
import ic_calender_green from "../../assets/images/ic_calender_green.svg";
import dog_1 from "../../assets/images/dog_1.png";
import dog_3 from "../../assets/images/dog_3.png";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import ic_progress from "../../assets/images/ic_progress.svg";
import ic_complete from "../../assets/images/ic_complete.svg";
import ic_reject from "../../assets/images/ic_reject.svg";
import ic_left_green_arrow from "../../assets/images/ic_left_green_arrow.svg";
import ic_star_active from "../../assets/images/ic_star_active.svg";
import ic_start from "../../assets/images/ic_start.svg";

import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import PrescriptionComp from "./PrescriptionComp";
import MedicalPrescriptionComp from "./MedicalPrescriptionComp";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCall, simpleGetCallWithErrorResponse, simplePatchCall, simplePatchCall2 } from "../../api/ApiServices";
import { notifySuccess } from "../../sharedComponent/notify";
import { Spinner } from "react-bootstrap";
const MyTransactionComp = () => {
    const { Prescription, setPrescription ,selectedStore, loginType, jobApiRefresh} = useContext(AppContext);
 
   
      const orderStatusMap = {
    0: "Order Received",
    1: "Rider Assigned",
    2: "Picked Up",
    3: "Ready to Deliver",
    4: "Payment Done",
    5: "Delivered",
    6: "Returned",
    7: "Return Back to Warehouse",
    8: "Rider Arrived",
    9: "Delivery Person Reached for Delivery",
    10: "Cancelled",
    11: "Pending Refund",
    12: "Failed Refund",
    13: "Processed Refund",
    14: "Order Accepted",
    15: "Preparing Order"
  };


// STATES

const [selectedOption, setSelectedOption] = useState("last_2_days");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [selectedStatus, setSelectedStatus] = useState("all");
const [OrderNumber, setOrderNumber] = useState("");
const [orderListData, setOrderListData] = useState([]);
const [orderDetails, setOrderDetails] = useState([]);
 const [Loading, setLoading] = useState(false);
  const [showChart, setShowChart] = useState(false);
  
  const [ChatData, setChatData] = useState([]);
    const statusOptions = [
    { value: "all", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "accepted", label: "Accepted" },
    { value: "cancelled", label: "Cancelled" },
    { value: "delivered", label: "Delivered" },
    { value: "ready_to_deliver", label: "Ready to Deliver" },
  ];
 

  useEffect(() => {
    if (selectedStore) {
      fetchStatusList();
    }
  }, [
    selectedStore,
    selectedOption,
    selectedStatus,
    startDate,
    endDate,
    OrderNumber,
    // jobApiRefresh,
  ]);



  useEffect(() => {

      fetchAppointmentList();

  }, []);




const fetchAppointmentList = async () => {
  // setLoading(true);

  try {
    const res = await simpleGetCallWithErrorResponse(
      `${ApiConfig?.OrderList}?shop_id=${selectedStore}&recordType=${selectedOption}&status=${selectedStatus}&start_date=${startDate}&end_date=${endDate}&order_no=${OrderNumber}`
    // `${ApiConfig?.OrderList}?shop_id=${selectedStoreID}&recordType=${selectedOption}&status=${selectedStatus}&start_date=${startDate}&end_date=${endDate}&order_no=${OrderNumber}`

   , "Bearer" );

  

    if (res.json.success) {
     setOrderListData(res.json.data)
    } else {
      // setLoading(false);
    }
  } catch (err) {
    console.error("Appointment API Error:", err);
  }
};


const getOrderDetails = async (orderId) => {
  // setLoading(true);

  try {
    const res = await simpleGetCallWithErrorResponse(
      `${ApiConfig?.OrderList}/${orderId}`
    , "Bearer" );

  

    if (res.json.success) {
     setOrderDetails(res.json.data)
    } else {
      // setLoading(false);
      setOrderDetails([]);
    }
  } catch (err) {
    console.error("Appointment API Error:", err);
      setOrderDetails([]);
  }
};

const handleClickView = (orderID) => {
getOrderDetails(orderID);
setPrescription(true);

}


  // useEffect(() => {
  //   fetchChartView();
  // }, [selectedStore]);

  const fetchChartView = async () => {
    try {
      const res = await simpleGetCall(ApiConfig?.CHAT_VIEW + selectedStore);
      console.log(res);

      const itemlist = res.data;
      if (res.success) {
        setChatData(itemlist);
      } else {
        // setdataView();
      }
    } catch (err) {
      console.error("Status API Error:", err);
    }
  };


const fetchStatusList = async () => {
    setLoading(true);

    try {
      const res = await simpleGetCallWithErrorResponse(
       ` ${ApiConfig?.OrderList}?shop_id=${selectedStore}&recordType=${selectedOption}&status=${selectedStatus}&start_date=${startDate}&end_date=${endDate}&order_no=${OrderNumber}`
     , "Bearer" );

      const itemlist = res.json.data;
      if (res.json.success) {
        setOrderListData(itemlist);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Status API Error:", err);
    }
  };

const [isUpdating, setIsUpdating] = useState(false);
const [orderStatusLoading, setOrderStatusLoading] = useState(false);

 const OrderStatusChange = async (newStatus, id) => {

    if (isUpdating) return; // prevent multiple calls

    setIsUpdating(true); // block further clicks
    setOrderStatusLoading(true);
    try {
      const requestBody = {
        status: newStatus,
        id: id,
      };

      const res = await simplePatchCall2(`${ApiConfig?.CHANGE_STAUS_ORDER}`, requestBody);
      if (res.success) {
        notifySuccess(res.message);
        fetchStatusList();
        // fetchChartView();
      }
      console.log("Response:", res);
    } catch (err) {
      console.error("Status API Error:", err);
    } finally {
      setIsUpdating(false); // re-enable button
      setOrderStatusLoading(false);
    }
  };

  return (
    <div className="main-MyTransactionComp">
    <section className="wrapper-cards">
  <div className="row align-items-end g-3">

    {/* Record Type */}
    {/* <div className="col-md-3">
   
      <select
        className="form-select"
        value={selectedOption}
        onChange={(e) => setSelectedOption(e.target.value)}
      >
        <option value="last_2_days">Last 2 Days</option>
        <option value="last_5_days">Last 5 Days</option>
        <option value="">Custom Date Range</option>
      </select>
    </div> */}


    <div className="dropdown col-md-3">
  <button
    className="btn btn-light d-flex justify-content-evenly align-items-center form-select"
    style={{
      width: "170px",
      height: "40px",
    }}
    type="button"
    id="dropdownMenuButton1"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {
      [
        { value: "last_2_days", label: "Last 2 Days" },
        { value: "last_5_days", label: "Last 5 Days" },
        { value: "", label: "Custom Date Range" }
      ].find((option) => option.value === selectedOption)?.label
    }
    <span className="" style={{ scale: "1.2" }}></span>
  </button>

  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
    {[
      { value: "last_2_days", label: "Last 2 Days" },
      { value: "last_5_days", label: "Last 5 Days" },
      { value: "", label: "Custom Date Range" }
    ].map((option) => (
      <li key={option.value}>
        <button
          className="dropdown-item"
          onClick={() => setSelectedOption(option.value)}
        >
          {option.label}
        </button>
      </li>
    ))}
  </ul>
</div>



    {/* Appointment Number */}
    <div className="col-md-3">

      <input
        className="form-control"
        placeholder="Order Number"
        value={OrderNumber}
        onChange={(e) => setOrderNumber(e.target.value)}
      />
    </div>

    {/* Status Dropdown */}
    <div className="col-md-3">
    
   


         <div className="dropdown">
                  <button
                    className="btn btn-light d-flex justify-content-evenly align-items-center form-select"
                    style={{
                      width: "170px",
                      height: "40px",
                    }}
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {
                      statusOptions.find(
                        (option) => option.value === selectedStatus
                      )?.label
                    }
                    <span className="" style={{ scale: "1.2" }}></span>
                  </button> 

                  

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    {statusOptions.map((option) => (
                      <li key={option.value}>
                        <button
                          className="dropdown-item"
                          onClick={() => setSelectedStatus(option.value)}
                        >
                          {option.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
    </div>

    {/* Custom Date Range Fields */}
    {selectedOption === "" && (
      <>
        <div className="col-md-3">
          <label className="my-2">Start Date</label>
          <input
            type="date"
            className="form-select"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label className="my-2">End Date</label>
          <input
            type="date"
            className="form-select"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </>
    )}

  </div>
</section>


      <div className="table-wrapper-main wrapper-cards mt-3">
        <div className="t-wrapper-inner">
          <table>
            <thead>
              <tr>
                <th>Order No</th>
                <th>Order Name</th>
                <th>Order Type</th>
                <th>Customer Details</th>
                {/* <th>OTP</th> */}
                <th>Date & Time</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orderListData?.length > 0 ? orderListData?.map((order) => (
<tr key={order.id}>
                <td>{order.id} <br/> {`(${order.payment_type})`} </td>
                <td>{order.restaurant_name} <br/> {`[${order.ondc_bap}]`}</td>
              
                <td>{order.order_type == 'H' ? "Home Delivery" : order.order_type == 'P' ? "Parcel" : '' }</td>
                <td>{order.first_name} <br/> {`[${order.phone_number}]`}</td>
                {/* <td>{order.otp}</td> */}
                <td>
                  {/* {`Status:  ${orderStatusMap[order.order_status] || "Unknown status"} `} <br/> {`Created At : ${order.created_on}`} */}
                   Created: {order.dateCreated} {order.timeCreated}
                            {/* Nested Data Example */}
                            {order.order_statuses &&
                              order.order_statuses.map((status, i) => (
                                <div key={i} className="nested-status">
                                  Status:{" "}
                                  {orderStatusMap[status.order_status] ||
                                    "Unknown Status"}{" "}
                                  <br />
                                  Created At: {status.created_at}
                                </div>
                              ))}
                            <br />
                  </td>
                <td>{order.total} </td>
                <td>
                   {order?.upcoming_status?.upcoming_status && (
 <button
                                
                                className="button-main"
                                  disabled={isUpdating} 
                                 onClick={(e) => {
        console.log("Clicked upcoming status:", order.upcoming_status);
        OrderStatusChange(order.upcoming_status.upcoming_status, order.id);
      }}
                              >
                           {/* orderStatusLoading ? <Spinner size="sm" /> : */ order.upcoming_status.upcoming_status_name}
                              </button>
                   )}
                              <br/>
                              {Number(order.order_status) === 0 && (

 <button
                                  disabled={isUpdating} 
                                className="button-main mt-2"
                                 onClick={(e) => {
        console.log("Clicked cancel button");
        OrderStatusChange("10", order.id);
      }}
                              >
                                Cancel
                              </button>
                              )}

                </td>
                <td>
                 <p style={{cursor:'pointer'}} onClick={()=> handleClickView(order.id)}>View</p>
                </td>
                </tr>
              )) :

              (<tr className="d-flex justify-content-center mt-4">
              <p>No data found</p>
          </tr>)}
           
            </tbody>
          </table>
        </div>
        <MedicalPrescriptionComp orderDetails={orderDetails} orderStatusMap={orderStatusMap}/>
        <div className="pagination-wrapper">
          {/* <label htmlFor="">Showing 1- 10 of 20 </label> */}
        </div>
      </div>
    </div>
  );
};

export default MyTransactionComp;
